export { default as TablePaginated } from './paginated'
